export default {
    CONSULTA_AGENDADA_PROGRAMADA_CUIDADO_CONTINUADO: 1,
    CONSULTA_AGENDADA: 2,
    ESCUTA_INICIAL_ORIENTACAO: 3,
    CONSULTA_NO_DIA: 4,
    ATENDIMENTO_DE_URGENCIA: 5,
    ATENDIMENTO_PROGRAMADO: 6,
    ATENDIMENTO_NAO_PROGRAMADO: 7,
    VISITA_DOMICILIAR_POS_OBITO: 8,
}